import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo-white-svg.svg";

function NavbarComponent() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinkClass = ({ isActive }) =>
    isActive ? "nav-link active" : "nav-link";

  const closeMenu = () => {
    const offcanvas = document.getElementById("mobileMenu");
    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvas);
    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg fixed-top ${
          scrolled ? "navbar-dark bg-dark" : "navbar-dark"
        }`}
      >
        <div className="container">

          <NavLink className="navbar-brand" to="/">
            <img src={logo} alt="Leocord" height="30"/>
            <span className="brand-name">Leocord</span>
          </NavLink>

          {/* Mobile Button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop Menu */}
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink to="/" className={navLinkClass}>Home</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/about" className={navLinkClass}>About</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/products" className={navLinkClass}>Products</NavLink>
              </li>

              <li className="nav-item">
                <NavLink to="/contact" className={navLinkClass}>Contact</NavLink>
              </li>
            </ul>
          </div>

        </div>
      </nav>


      {/* Offcanvas Side Menu */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="mobileMenu"
      >
        <div className="offcanvas-header">
          <h5>Leocord</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body">
          <ul className="navbar-nav">

            <li className="nav-item">
              <NavLink to="/" className={navLinkClass} onClick={closeMenu}>Home</NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/about" className={navLinkClass} onClick={closeMenu}>About</NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/products" className={navLinkClass} onClick={closeMenu}>Products</NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/contact" className={navLinkClass} onClick={closeMenu}>Contact</NavLink>
            </li>

          </ul>
        </div>
      </div>
    </>
  );
}

export default NavbarComponent;